<div class="subbanner" [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
   <!-- <img src="../../assets/img/itinary.jpg" class="Itineraries-country-banner" alt="banner-image" loading="lazy"> -->
   <div class="container position-relative">
      <div class="subbanner__title">
         <h1 class="primary-title">Photo Gallery</h1>
      </div>
   </div>
</div>

<div class="container-fluid padding-section" [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
   <div class="photo-gallery">
      <!-- <h2>Lightbox Example</h2> -->
      <div class="container">

         <!-- <div class="row">
            <div class="col-md-4 photo-gallery-images" *ngFor="let item of items; index as i"> -->
         <ul class="photo-gallery__list list-unstyled">
            <li *ngFor="let item of galleryItem; index as i" [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
               <!-- <a [href]="item.image" target="_blank"> -->
               <img [src]="item.image" [alt]="item.title" width="284" height="200" loading="lazy" (click)="showLightbox(i)">
               <!-- </a> -->
            </li>
         </ul>
         <ng-image-fullscreen-view [images]="galleryItem" [imageIndex]="currentIndex" [show]="showFlag"
            (close)="closeEventHandler()"></ng-image-fullscreen-view>

         <!-- </div>
         </div> -->
      </div>
   </div>
</div>

<!-- <img 
         [lightbox]="i" width="100%" 
         [src]="item.data.thumb"> -->